import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { Pagination } from 'swiper/modules';
import { FaBed, FaHardHat, FaMapMarkerAlt, FaLeaf } from 'react-icons/fa';
import { GiCoffeeBeans, GiMountainCave } from 'react-icons/gi';
import './index.css';

const TravelCards = () => {
  const cardsData = [
    {
      image: 'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2FBanner%2FFull%20Villa%201.jpg?alt=media&token=4c048dee-e8ee-4252-9753-6370c4cd279c',
      tag: 'Karnataka Highlands',
      location: 'Sakleshpur',
      icon: <GiCoffeeBeans size={22} />,
      description: 'Blanketed by sprawling coffee and spice estates, Sakleshpur offers mist-covered mornings, gurgling streams, and the rustle of pepper vines. An idyllic luxury retreat for those who love nature in its most aromatic form.',
      details: [
        { icon: <FaBed size={14} />, text: '2 Bedroom Villa' },
        { icon: <FaHardHat size={14} />, text: 'Under Construction' },
        { icon: <FaLeaf size={14} />, text: 'Coffee Estate Surroundings' },
      ],
    },
    {
      image: 'https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2FBanner%2Fmodel%20house%20image.jpg?alt=media&token=7ebd4645-480b-4389-8f49-795b4391040a',
      tag: 'Western Ghats',
      location: 'Anaikatti',
      icon: <GiMountainCave size={22} />,
      description: 'Perched atop the hills on the Kerala–Tamil Nadu border, Anaikatti is defined by dense shola forests, cascading waterfalls, and cool highland winds. Overlooking the Bhavani River, this exclusive hilltop sanctuary offers sweeping views that stretch endlessly into the horizon.',
      details: [
        { icon: <FaBed size={14} />, text: '3 Bedroom Villa' },
        { icon: <FaHardHat size={14} />, text: 'Under Construction' },
        { icon: <FaMapMarkerAlt size={14} />, text: 'Kerala–Tamil Nadu Border' },
      ],
    }
  ];

  const CardContent = ({ card }) => (
    <div className="lu-card">
      <div className="lu-card-img-wrap">
        <img src={card.image} alt={card.location} className="lu-card-img" />
        <span className="lu-card-tag">{card.tag}</span>
      </div>
      <div className="lu-card-body">
        <div className="lu-card-header">
          <span className="lu-card-icon">{card.icon}</span>
          <h3 className="lu-card-title">{card.location}</h3>
        </div>
        <div className="lu-card-divider" />
        <p className="lu-card-desc">{card.description}</p>
        <ul className="lu-card-details">
          {card.details.map((d, i) => (
            <li key={i}>
              <span className="lu-detail-icon">{d.icon}</span>
              {d.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );

  return (
    <div className="lu-collection-wrap">
      <p className="lu-collection-label">Curated Escapes</p>
      <h2 className="lu-collection-title">India Untamed Collections</h2>
      <p className="lu-collection-sub">Handpicked luxury villas in India's most breathtaking wilderness destinations.</p>

      {/* Desktop */}
      <div className="lu-cards-grid d-none d-md-flex">
        {cardsData.map((card, i) => (
          <CardContent key={i} card={card} />
        ))}
      </div>

      {/* Mobile Swiper */}
      <div className="d-md-none lu-swiper-wrap">
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          centeredSlides={true}
          pagination={{ clickable: true }}
          modules={[Pagination]}
          className="lu-swiper"
        >
          {cardsData.map((card, i) => (
            <SwiperSlide key={i}>
              <CardContent card={card} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="lu-cta-wrap">
        <Link to="/invitation-form" className="lu-cta-btn">Seek Invitation</Link>
      </div>
    </div>
  );
};

export default TravelCards;
